var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6096 1.66675C16.4346 1.66675 18.3346 3.65008 18.3346 6.59175V13.4001C18.3346 16.3501 16.4346 18.3334 13.6096 18.3334H6.38463C3.56047 18.3334 1.66797 16.3501 1.66797 13.4001V6.59175C1.66797 3.65008 3.56047 1.66675 6.38463 1.66675H13.6096ZM10.0013 5.97508C9.6513 5.97508 9.3763 6.25008 9.3763 6.60008V11.8917L7.31797 9.82508C7.2013 9.70841 7.03464 9.64175 6.8763 9.64175C6.7188 9.64175 6.55964 9.70841 6.43464 9.82508C6.19297 10.0667 6.19297 10.4667 6.43464 10.7084L9.55964 13.8501C9.79297 14.0834 10.2096 14.0834 10.443 13.8501L13.568 10.7084C13.8096 10.4667 13.8096 10.0667 13.568 9.82508C13.318 9.58341 12.9263 9.58341 12.6763 9.82508L10.6263 11.8917V6.60008C10.6263 6.25008 10.343 5.97508 10.0013 5.97508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquare);
export default __webpack_public_path__ + "static/media/arrow-square.29afe61b51ebc7dd952bf3d5a4ffd420.svg";
export { ForwardRef as ReactComponent };